import createReducer from '../utils/createReducer';
import ActionTypes from '../constants/ActionTypes';
import { combineReducers } from 'redux';

const list = createReducer(
  {},
  {
    [ActionTypes.FETCH_CONTACTS_SUCCESS]: (state, { payload }) => {
      return { ...state, ...payload };
    }
  }
);

const status = createReducer(null, {
  [ActionTypes.FETCH_CONTACTS_ERROR]: () => ActionTypes.FETCH_CONTACTS_ERROR,
  [ActionTypes.FETCH_CONTACTS_REQUEST]: () => ActionTypes.FETCH_CONTACTS_REQUEST,
  [ActionTypes.FETCH_CONTACTS_SUCCESS]: () => ActionTypes.FETCH_CONTACTS_SUCCESS
});

export default combineReducers({
  list,
  status
});
